import React, { createContext, useContext, useEffect, useState } from "react";
import {
  open_api_with_cookies,
  registerLogoutHandler,
} from "../../Utils/network";

// Create the AuthContext
const AuthContext = createContext();

// AuthProvider Component
export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [userName, setUserName] = useState("");
  const [userId, setUserId] = useState("");
  const [isAuthLoading, setIsAuthLoading] = useState(true);

  // Check auth on mount using secure endpoint (cookie is sent automatically)

  useEffect(() => {
    registerLogoutHandler(logout);
  }, []);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const response = await open_api_with_cookies.get("/profiles/me/"); // Backend should return user info if cookie is valid
      if (
        response.status === 200 ||
        response.status === 201 ||
        response.status === 204
      ) {
        const fullName =
          response.data.first_name + " " + response.data.last_name;

        setIsAuthenticated(true);
        setUserName(fullName);
      } else {
        setIsAuthenticated(false);
        setUserName("");
      }
    } catch (error) {
      setIsAuthenticated(false);
      setUserName("");
      setUserId("");
    } finally {
      setIsAuthLoading(false);
    }
  };

  // Logout
  const logout = async () => {
    try {
      await open_api_with_cookies.post("/auth/logout/"); // Backend clears cookie
    } catch (err) {
      console.error("Logout failed", err);
    }

    setIsAuthenticated(false);
    setUserName("");
    setUserId("");
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        setIsAuthenticated,
        userName,
        userId,
        logout,
        setUserName,
        setUserId,
        checkAuth,
        isAuthLoading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to use AuthContext
export const useAuth = () => useContext(AuthContext);

export default useAuth;
